export default __webpack_public_path__ + "static/media/WFTM.df0053d8.svg";